import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  /* Font imports handled in index.html */
  
  :root {
    --primary: #F05A28;
    --secondary: #0E1330;
    --accent: #00ADEE;
    --white: #FFFFFF;
  }
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  body {
    font-family: 'Open Sans', sans-serif;
    color: var(--secondary);
    background-color: var(--white);
    overflow-x: hidden;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    margin-bottom: 1rem;
  }
  
  p {
    margin-bottom: 1rem;
    line-height: 1.6;
  }
  
  a {
    text-decoration: none;
    color: inherit;
  }
  
  button {
    font-family: 'Open Sans', sans-serif;
    cursor: pointer;
    border: none;
    outline: none;
  }
  
  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
  }
  
  section {
    padding: 5rem 0;
  }
  
  @media (max-width: 768px) {
    section {
      padding: 3rem 0;
    }
  }

  .material-icons {
    vertical-align: middle;
    margin-right: 0.5rem;
  }
`;

export default GlobalStyles;
